var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 0)?_c('u-icon',{staticClass:"level1-icon fa-fw",attrs:{"name":"envelope","type":"fa","icon-style":"light"}}):(_vm.type === 1)?_c('u-icon',{staticClass:"level1-icon fa-fw",attrs:{"name":"file","type":"fa","icon-style":"light"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }